<script>
import TenantInfo from '@/tenant/components/TenantInfo.vue';
import TenantConfiguration from '@/tenant/components/TenantConfiguration.vue';

export default {
  components: {
    TenantInfo,
    TenantConfiguration,
  },

  data: () => ({
    tenant: undefined,
    configuration: undefined,
  }),
}
</script>

<template>
  <div>

    <api-loader
      method="get"
      url="v1/user/tenant"
      @loaded="tenant=$event" />

    <div v-if="tenant">
      <tenant-info
        :tenant="tenant" />

      <api-loader
        v-if="tenant.permissions.admin_of_tenant"
        method="get"
        url="v1/tenant/configuration"
        @loaded="configuration=$event">

        <tenant-configuration
          v-if="configuration"
          :configuration="configuration"
          @updated="configuration=$event"
          class="mt-3" />

      </api-loader>

    </div>

  </div>
</template>



// WEBPACK FOOTER //
// src/tenant/views/TenantOverviewView.vue